"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lodash = _interopRequireDefault(require("lodash"));

var _index = require("./index");

var _config = require("./config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaContainer = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var classes = _ref.classes;
      return classes;
    },
    message: 'Use of classes prop will be depreciated. Please use className prop instead.',
    breakingVersion: 4
  }, {
    condition: function condition(_ref2) {
      var _ref2$divider = _ref2.divider,
          divider = _ref2$divider === void 0 ? {} : _ref2$divider;
      return divider.hasOwnProperty('size') && divider.size === _index.LunaContainerDividers.size.fourty;
    },
    message: 'LunaContainerDividers.size.fourty is deprecated. Please use LunaContainerDividers.size.forty instead.',
    breakingVersion: 4
  }, {
    condition: function condition(_ref3) {
      var _ref3$divider = _ref3.divider,
          divider = _ref3$divider === void 0 ? [] : _ref3$divider;
      return !_lodash["default"].isArray(divider) && !_lodash["default"].isString(divider);
    },
    message: 'The props pattern of <LunaContainer divider={{direction: LunaContainerDividers.direction.<direction>, size: LunaContainerDividers.size.<size>}} /> is deprecated and will throw an error in version 4. Please provide an array of dividers using the enums namespaced by "l<size>" instead: <LunaContainer divider={[LunaContainerDividers.l20.all]} />.',
    breakingVersion: 4
  }, {
    condition: function condition(_ref4) {
      var _ref4$margin = _ref4.margin,
          margin = _ref4$margin === void 0 ? [] : _ref4$margin;
      return !_lodash["default"].isArray(margin) && !_lodash["default"].isString(margin);
    },
    message: 'The props pattern of <LunaContainer margin={{direction: LunaContainerMargins.direction.<direction>, size: LunaContainerMargin.size.<size>}} /> is deprecated and will throw an error in version 4. Please provide an array of margins using the enums namespaced by "l<size>" instead: <LunaContainer divider={[LunaContainerMargins.l20.bottom, LunaContainerMargins.l10.horizontal]} />.',
    breakingVersion: 4
  }, {
    condition: function condition(_ref5) {
      var _ref5$padding = _ref5.padding,
          padding = _ref5$padding === void 0 ? [] : _ref5$padding;
      return !_lodash["default"].isArray(padding) && !_lodash["default"].isString(padding);
    },
    message: 'The props pattern of <LunaContainer padding={{direction: LunaContainerPaddings.direction.<direction>, size: LunaContainerPaddings.size.<size>}} /> is deprecated and will throw an error in version 4. Please provide an array of paddings using the enums namespaced by "l<size>" instead: <LunaContainer divider={[LunaContainerPaddings.l20.bottom, LunaContainerPaddings.l10.horizontal]} />.',
    breakingVersion: 4
  }], _objectSpread({}, props));
  var className = props.className,
      classes = props.classes,
      component = props.component,
      id = props.id,
      divider = props.divider,
      margin = props.margin,
      padding = props.padding,
      theme = props.theme,
      children = props.children,
      other = props.other,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart;

  var getContainerClassList = function getContainerClassList() {
    var returnClasses = function returnClasses(passedProp, enumType, enumSet) {
      if (typeof passedProp === 'string') {
        if (enumType === 'themes') {
          return _config.containerClasses.themes[passedProp];
        }

        return passedProp;
      }

      var direction = enumSet.direction,
          size = enumSet.size,
          levels = _objectWithoutProperties(enumSet, ["direction", "size"]);

      var DEPRECATEDclassNameSet = [];

      if (_lodash["default"].isObject(passedProp) && !_lodash["default"].isArray(passedProp)) {
        if (passedProp.direction && passedProp.size) {
          DEPRECATEDclassNameSet.push(_config.containerClasses[enumType][(0, _config.DEPRECATEDclassKeyFromEnumSet)(passedProp.direction, passedProp.size)]);
        } else {
          DEPRECATEDclassNameSet.push(Object.values(passedProp).join(' '));
        }
      }

      var classNameSet = [];

      if (_lodash["default"].isArray(passedProp)) {
        classNameSet = passedProp.map(function (prop) {
          var levelKey;
          var directionKey;

          _lodash["default"].forEach(levels, function (directions, lKey) {
            var dkey = _lodash["default"].findKey(directions, function (d) {
              return d === prop;
            });

            if (dkey) {
              levelKey = lKey;
              directionKey = dkey;
            }
          });

          return _config.containerClasses[enumType][(0, _config.classKeyFromEnumSet)(levelKey, directionKey)];
        });
      }

      return _lodash["default"].uniq([].concat(DEPRECATEDclassNameSet, _toConsumableArray(classNameSet)));
    };

    return (0, _classnames["default"])(returnClasses(divider, 'dividers', _index.LunaContainerDividers), returnClasses(margin, 'margins', _index.LunaContainerMargins), returnClasses(padding, 'paddings', _index.LunaContainerPaddings), returnClasses(theme, 'themes', _index.LunaContainerThemes), className, classes);
  };

  var ComponentTag = component || 'div';
  return _react["default"].createElement(ComponentTag, _extends({}, other, {
    className: getContainerClassList(),
    ref: ref,
    id: id,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  }), children);
});

LunaContainer.displayName = 'LunaContainer';
LunaContainer.ENUMS = _config.ENUMS;
LunaContainer.defaultProps = {
  other: {}
};
LunaContainer.propTypes = {
  className: _propTypes["default"].string,
  classes: _propTypes["default"].string,
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].elementType]),
  id: _propTypes["default"].string,
  divider: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].array]),
  margin: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].array]),
  padding: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].array]),
  theme: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  children: _propTypes["default"].any,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
var _default = LunaContainer;
exports["default"] = _default;
